export const Props = () => ({
  //Название текстового поля
  label: {
    type: String,
    required: false,
  },

  //Дополнительная подпись поля
  option: {
    type: String,
    required: false,
  },

  //Текущая длина поля
  counter:{
    type: Number,
    required: false,
  },

  //Максимально допустимая длина поля
  maxItems: {
    type: Number,
    required: false,
  },
})
